import './src/styles/normalize.css';
import './src/styles/global.scss';
import 'katex/dist/katex.min.css';
import 'react-live/react-live.css';

import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';

library.add(fab);
library.add(fas);
library.add(far);
